// extracted by mini-css-extract-plugin
module.exports = {"editLogo":"styles_editLogo__1aUfz","editStartImage":"styles_editStartImage__3AFeP"};